import { reactive } from 'vue';
import RoomVO from '@/ts/VO/RoomVO';

// RoomNumber(GameType-GameCode) -> RoomName(桌名, 如 AS2/RB...)
// 由首页从 GetRoomList 填充（服务端下发数据，非客户端硬编码），列表与详情共用
const roomNameMap = reactive<Record<string, string>>({});

export function setRoomNameMap(list: RoomVO[] | null | undefined) {
  for (const k of Object.keys(roomNameMap)) delete roomNameMap[k];
  for (const r of list ?? []) {
    const num = r?.RoomNumber;
    const name = r?.RoomName;
    if (num && name) roomNameMap[num] = name;
  }
}

// 解析房间显示名：优先服务端桌名，拿不到再退回原始房间号（如 3001-xx）
export function resolveRoomName(room: string | null | undefined): string {
  if (!room) return '';
  return roomNameMap[room] || room;
}
